/**
 * @fileoverview Custom hook for scrolling to top when specific triggers change.
 */

import {useEffect} from "react";

import {scrollToTop} from "./useScrollToTopOnHistoryChange";

/**
 * Custom hook that scrolls to the top of a specified element when triggers change.
 * Uses requestAnimationFrame to ensure smooth scrolling.
 *
 * @param {string} selector CSS selector for the element to scroll to top.
 * @param {any[]} scrollTriggers Array of dependencies that trigger the scroll effect.
 */
export const useScrollTopEffect = (selector: string, scrollTriggers: any[]) =>
  useEffect(() => {
    requestAnimationFrame(() => scrollToTop(selector));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selector, ...scrollTriggers]);
